"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validLegacyPre1987LoanStatusCodes = exports.validClaimAccountStatusTypeCodes = void 0;
exports.validClaimAccountStatusTypeCodes = [
    "06" /* APPROVED */,
    "09" /* FINALIZED */,
    "07" /* ISSUE */,
];
exports.validLegacyPre1987LoanStatusCodes = ["4" /* VALID */];
